// import React, { useEffect, useState, useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// import { Buffer } from "buffer";
// import dayjs from "dayjs";
// import { UserContext } from "../../../core/store/contexts/UserContext";
import { useAuthStore } from "../../../core/store/auth.store";
import LoaderScreen from "../../../components/loaders/LoaderScreen";
import { FC, ReactNode } from "react";


interface ProtectedRouteProps {
  children?: ReactNode;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isLoading) return <LoaderScreen />;
  
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si hay children, renderízalos; si no, renderiza <Outlet />
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;

// const ProtectedRoute = (props: any) => {
//   const { tokenUser, idTokenUser, idRuta } = useContext(UserContext);
//   const navigate = useNavigate();
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const checkUserToken = () => {
//     if (!tokenUser || tokenUser === undefined) {
//       idRuta(undefined);
//       setIsLoggedIn(false);
//       return navigate("/");
//     }   

//     idRuta(window.location.pathname);
//     idTokenUser(tokenUser);
//     setIsLoggedIn(true);    
    
//   };

//   useEffect(() => {
//     checkUserToken();
//   }, [isLoggedIn]);
//   return <React.Fragment>{isLoggedIn ? props.children : null}</React.Fragment>;
// };
// export default ProtectedRoute;
